import axios from "axios";
import { DateBox, NumberBox, TextBox } from "devextreme-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ColumnDropdown } from "../../../../components/Dropdownn";
import { logOut } from "../../../../components/Logout";
import {
  detail_Tab_Name_getData,
  detail_name_tab_Validation,
  setefffectiveData,
  setfirstnamevalidation,
} from "../../../../reducer/ParticipateReducer";
import { handleGetLocal } from "../../../../services/auth-service";
import { ApiError } from "../../../Error/ApiError";
// import { SaveBody } from "../../Participant/ParticipantsValidationFunction";
import { getDateFormat } from "../../../Dateapi/Dateapi";
import { getDateBoxFormat } from "../../../Dateapi/dateFormatter";
const DropDown = ({
  dropDownData,
  setfields,
  Detail_Tab_Name_getData,
  setValue,
  reset,
  editable,
  stateparticipent,
  searchMode,
  disabled = false,
}) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={detail_Tab_Name_getData}
        fields={Detail_Tab_Name_getData}
        fieldNmae={setValue}
        value={Detail_Tab_Name_getData[setValue]?.name}
        // reset={reset}
        margin={"7px"}
        disabled={disabled || !editable}
        redux={true}
        resetErrorHandling={true}
        stateparticipent={stateparticipent}
        searchMode={searchMode}
      />
    </>
  );
};

export const Detail_Name_Tab = ({ editable, editParticipant }) => {
  const pathname = handleGetLocal("pathURL");
  const {
    Detail_Tab_Name_getData,
    Detail_Tab_address_getData,
    Detail_co_obligor_Tab_getData,
    Detail_Payment_Tab_getData,
    Detail_Notification_Tab_getData,
    GPersonTextContactInfoId,
    GPersonEmailContactInfoId,
    Detail_name_tab_Validation,
    efffectiveData,
    stateparticipent,
    firstnamevalidation,
    userinfo,
  } = useSelector((store) => store.participate);

  const dispatch = useDispatch();
  const [gender, setgender] = useState([]);
  const [eyeColor, seteyeColor] = useState([]);
  const [hairColor, sethairColor] = useState([]);
  const [languages, setlanguage] = useState([]);
  const [race, setRace] = useState([]);
  const [complianceLevel, setcomplianceLevel] = useState();
  const [statePreferences, setstatePreferences] = useState([]);
  const navigate = useNavigate();
  const [errorhandling, seterrorhandling] = useState(false);
  const [changeStatePopup, setChangeStatePopup] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [dateformat, setDateFormat] = useState("MM/DD/YYYY");
  const [loading, setloading] = useState(false);

  console.log("dateformat in name tab", dateformat);

  useEffect(() => {
    getDateFormat(navigate, setloading, setDateFormat);
  }, []);

  const getDxFormat = (format) => {
    if (!format) return "MM/DD/YYYY";

    return format.replace("YYYY", "yyyy").replace("DD", "d").replace("MM", "M");
  };

  const getalldropdown = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/Person/masterDropDownValuesGet`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        seterrorhandling(false);
        const genderData = val?.data?.data?.gender;
        genderData?.reverse();
        setgender(
          genderData.map((vall) => {
            return { name: vall?.sName, id: vall?.sAbbr };
          }),
        );
        seteyeColor(
          val?.data?.data?.eyeColor?.map((vall) => {
            return { name: vall?.sName, id: vall?.gEyeColorId };
          }),
        );
        sethairColor(
          val?.data?.data?.hairColor?.map((vall) => {
            return { name: vall?.sName, id: vall?.gHairColorId };
          }),
        );
        setlanguage(
          val?.data?.data?.language?.map((vall) => {
            return { name: vall?.sName, id: vall?.gLanguageId };
          }),
        );
        setRace(
          val?.data?.data?.race?.map((vall) => {
            return { name: vall?.sName, id: vall?.gRaceId };
          }),
        );
        setcomplianceLevel(
          val?.data?.data?.complianceLevel?.map((vall) => {
            return { name: vall?.sName, id: vall?.gComplianceLevelId };
          }),
        );
        setstatePreferences(
          val?.data?.data?.statePreferences?.map((vall) => {
            return { name: vall?.sState, id: vall?.sState };
          }),
        );
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        } else {
          seterrorhandling(true);
        }
      });
  };

  const { user_data } = useSelector((store) => store.Home);

  useEffect(() => {
    if (editable) {
      statePreferences.forEach((state) => {
        if (state.name === user_data.sState) {
          dispatch(
            detail_Tab_Name_getData({
              ...Detail_Tab_Name_getData,
              StatePreference: state,
            }),
          );
        }
      });
    }
  }, [statePreferences]);

  useEffect(() => {
    getalldropdown();
  }, []);

  const validationChcek = (pattern, text) => {
    var passPattern = new RegExp(pattern);
    return passPattern.test(text);
  };

  const idd = useParams();
  const maskRules = {
    H: /^[0-9*]$/,
  };

  // const handleSaveState = () => {
  //   if (!selectedState) {
  //     alert("Please select a state before saving.");
  //     return;
  //   }

  // //   console.log("Selected State:", selectedState);
  // //   console.log("userinfo:", userinfo);
  // //   console.log('userdata',user_data)

  // //   const personId = user_data?.gPersonId || userinfo?.gPersonId;

  // // if (!personId) {
  // //   alert("Person ID not found. Cannot proceed.");
  // //   return;
  // // }

  //   const payload = {
  //     ...Detail_Tab_Name_getData,
  //     gPersonId: userinfo?.gPersonId,
  //     sOffenderNumber_State: selectedState,
  //   };

  //   console.log("Payload being sent to editPersonInfoDetail API:", payload);

  //   axios.post(
  //     `${process.env.REACT_APP_API_URL}/api/Person/editPersonInfoDetail`,
  //     payload,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //         Domain: `${pathname}`,
  //       },
  //     }
  //   )
  //     .then((response) => {
  //       console.log("Response from editPersonInfoDetail API:", response.data);

  //       if (response.data.isSuccess) {
  //         alert("State updated successfully!");
  //         setChangeStatePopup(false);
  //       } else {
  //         const errorMessage = response.data.errors?.[0] || "Failed to update state.";
  //         alert(errorMessage);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error while updating state:", error);
  //       alert("Failed to update state. Please try again.");
  //     });
  // };

  // const handleSaveState = () => {
  //   if (!selectedState) {
  //     alert("Please select a state before saving.");
  //     return;
  //   }

  //   const personId = user_data?.gPersonId || userinfo?.gPersonId;

  //   if (!personId) {
  //     alert("Person ID not found. Cannot proceed.");
  //     return;
  //   }

  //   // Create updated Detail_Tab_Name_getData with new state
  //   const updatedDetail_Tab_Name_getData = {
  //     ...Detail_Tab_Name_getData,
  //     StatePreference: { name: selectedState, id: selectedState },
  //     sOffenderNumber_State: selectedState,
  //     gPersonId: personId,
  //   };

  //   // Prepare final SaveBody
  //   const finalPayload = SaveBody(
  //     updatedDetail_Tab_Name_getData,
  //     personId,
  //     // Detail_Tab_address_getData,
  //     // Detail_co_obligor_Tab_getData,
  //     // Detail_Payment_Tab_getData,
  //     // Detail_Notification_Tab_getData,
  //     // GPersonTextContactInfoId,
  //     // GPersonEmailContactInfoId
  //   );

  //   console.log("Payload to API:", finalPayload);

  //   axios.post(
  //     `${process.env.REACT_APP_API_URL}/api/Person/editPersonInfoDetail`,
  //     finalPayload,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //         Domain: `${pathname}`,
  //       },
  //     }
  //   )
  //     .then((response) => {
  //       console.log("Response from API:", response.data);
  //       if (response.data.isSuccess) {
  //         alert("State updated successfully!");
  //         setChangeStatePopup(false);
  //       } else {
  //         const errorMessage = response.data.errors?.[0] || "Failed to update state.";
  //         alert(errorMessage);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("API Error:", error);
  //       alert("Failed to update state. Please try again.");
  //     });
  // };

  const ssnDigits = String(Detail_Tab_Name_getData?.SSN || "").replace(/\D/g, "");

  const ssnDisplayValue = editable ? ssnDigits : ssnDigits ? `*****${ssnDigits.slice(-4)}` : "";

  return (
    <>
      {errorhandling ? (
        <ApiError />
      ) : (
        <div className="commonBlock_Details_nav_tab">
          <div className="commonBlock_Details_nav_tab_uper">
            {/* <button
              onClick={() => setChangeStatePopup(true)}
              style={{
                background: "var(--button-lightblack-lightblue)",
                color: "var(--icons2)",
                fontWeight: "600",
              }}
            >
              Change State Prefix

            </button> */}

            {/* <Popup
              visible={changeStatePopup}
              showTitle={false}
              width={480}
              height="auto"
              position={{
                at: 'top',
                my: 'top',
                of: window,
                offset: '0 300'
              }}

            >

              <div
                style={{
                  backgroundColor: "#C3CCDB",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "30px",
                  paddingBottom: "30px",
                  // paddingLeft: "30px"

                }}
              >
                <label htmlFor="state" style={{
                  position: "absolute",
                  top: "12px",
                  left: "18px",
                }}>Select State</label>

                <div className="select-wrapper">
                  <select
                    id="state"
                    value={selectedState}
                    onChange={(e) => setSelectedState(e.target.value)}
                    style={{ width: "91%", padding: "8px", marginTop: "40px" }}

                  >
                    <option value="">California</option>
                    {statePreferences.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.name}
                      </option>
                    ))}

                  </select>
                </div>

                <div style={{ marginTop: "20px", textAlign: "right" }}>
                  <button className="btn btnlightblue" style={{
                    backgroundColor: "#E0E0E0",
                    border: "1px solid #999",
                    padding: "5px 15px",
                    fontWeight: "bold",
                    borderRadius: "3px",
                    cursor: "pointer",
                    height: "30px",
                    width: "93px"
                  }} >
                    Select
                  </button>
                </div>
              </div>
            </Popup> */}

            {/* <Popup
              visible={changeStatePopup}
              showTitle={false}
              width={480}
              height="auto"
              position={{
                at: 'top',
                my: 'top',
                of: window,
                offset: '0 300'
              }}
            >
              <div className="goto_obligation_change_financialStatus" style={{ height: "218px" }}>
                <div className="popup_header">
                  <div className="popup_header_title">
                    <div className="popup_header_title_data">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M0 0H24V24H0V0Z" fill="var(--button2)" />
                        <path
                          d="M20 3H19V2C19 1.45 18.55 1 18 1C17.45 1 17 1.45 17 2V3H7V2C7 1.45 6.55 1 6 1C5.45 1 5 1.45 5 2V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM19 21H5C4.45 21 4 20.55 4 20V8H20V20C20 20.55 19.55 21 19 21Z"
                          fill="white"
                        />
                      </svg>
                      <p>Change State Prefix</p>
                    </div>
                    <p className="popup_header_title_para">PS.7a</p>  Screen number
                  </div>
                  <svg
                    onClick={() => setChangeStatePopup(false)}
                    style={{ cursor: "pointer" }}
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <path
                      d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="popup-container-data">
                  <div className="edit_container_first">
                    <div className="edit_content_flex edit_content_space">
                      <p>
                        Select State <span className="marks_mandatary">*</span>
                      </p>
                      <SelectBox
                        dataSource={statePreferences}
                        displayExpr="name"
                        valueExpr="id"
                        value={selectedState}
                        placeholder="Select..."
                        onValueChange={(value) => setSelectedState(value)}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className="popup_buttons">
                    <button className="btn primary_btn" onClick={handleSaveState}>
                      Save
                    </button>
                    <button
                      className="btn"
                      onClick={() => setChangeStatePopup(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </Popup> */}

            <button
              style={{
                background: "var(--button-lightblack-lightblue)",
                color: "var(--icons2)",
                fontWeight: "600",
                display: "none",
              }}
            >
              Person Summary
              <svg
                className="svg-blue-white"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V14C16 11.34 10.67 10 8 10Z"
                  fill="#424167"
                />
              </svg>
            </button>
          </div>
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <div style={{ width: "25%" }}>
              <div className="Detail_Home_Tab_input_block_">
                <p>Alt ID</p>

                <TextBox
                  style={{
                    fontWeight: 600,
                    color: "rgba(0, 0, 0, 0.6)",
                    marginTop: "3%",
                  }}
                  value={Detail_Tab_Name_getData.AltID ? Detail_Tab_Name_getData.AltID : ""}
                  onValueChange={(e) => {
                    dispatch(
                      detail_Tab_Name_getData({
                        ...Detail_Tab_Name_getData,
                        AltID: e,
                        isChange: true,
                      }),
                    );
                  }}
                  disabled={!editable}
                  isValid={true}
                  placeholder={`Alt ID`}
                />
              </div>

              <div className="Detail_Home_Tab_input_block_">
                <p>
                  First Name <span className="mendatrystrick">*</span>
                </p>

                <TextBox
                  style={{
                    fontWeight: 600,
                    color: "rgba(0, 0, 0, 0.6)",
                    marginTop: "3%",
                  }}
                  value={Detail_Tab_Name_getData.FirstName}
                  onValueChange={(e) => {
                    dispatch(
                      detail_Tab_Name_getData({
                        ...Detail_Tab_Name_getData,
                        FirstName: e,
                        isChange: true,
                      }),
                    );
                    if (!e) {
                      dispatch(setfirstnamevalidation("Please Enter First Name"));
                    } else {
                      dispatch(setfirstnamevalidation(""));
                    }
                  }}
                  disabled={!editable}
                  isValid={true}
                  placeholder={`First Name`}
                />

                {firstnamevalidation && (
                  <p style={{ color: "red" }} className="Error">
                    {firstnamevalidation}
                  </p>
                )}
              </div>

              <div className="Detail_Home_Tab_input_block_">
                <p>Middle Name</p>

                <TextBox
                  style={{
                    fontWeight: 600,
                    color: "rgba(0, 0, 0, 0.6)",
                    marginTop: "3%",
                  }}
                  value={Detail_Tab_Name_getData.MiddleName}
                  onValueChange={(e) => {
                    dispatch(
                      detail_Tab_Name_getData({
                        ...Detail_Tab_Name_getData,
                        MiddleName: e,
                        isChange: true,
                      }),
                    );
                  }}
                  disabled={!editable}
                  isValid={true}
                  placeholder={`Middle Name`}
                />
              </div>

              <div className="Detail_Home_Tab_input_block_">
                <p>
                  Last Name <span className="mendatrystrick">*</span>
                </p>

                <TextBox
                  style={{
                    fontWeight: 600,
                    color: "rgba(0, 0, 0, 0.6)",
                    marginTop: "3%",
                  }}
                  value={Detail_Tab_Name_getData.LastName}
                  onValueChange={(e) => {
                    dispatch(
                      detail_Tab_Name_getData({
                        ...Detail_Tab_Name_getData,
                        LastName: e,
                        isChange: true,
                      }),
                    );
                    if (validationChcek("^[^0-9]*$", e)) {
                      dispatch(
                        detail_name_tab_Validation({
                          ...Detail_name_tab_Validation,
                          LastName: "",
                        }),
                      );
                    } else {
                      dispatch(
                        detail_name_tab_Validation({
                          ...Detail_name_tab_Validation,
                          LastName: "Please Enter Valid Last Name",
                        }),
                      );
                    }

                    if (!e) {
                      dispatch(
                        detail_name_tab_Validation({
                          ...Detail_name_tab_Validation,
                          LastName: "Please Enter Last Name",
                        }),
                      );
                    }
                  }}
                  disabled={!editable}
                  isValid={true}
                  placeholder={`Last Name`}
                />

                {Detail_name_tab_Validation.LastName && (
                  <p style={{ color: "red" }} className="Error">
                    {Detail_name_tab_Validation.LastName}
                  </p>
                )}
              </div>
            </div>
            <div style={{ width: "25%" }}>
              <div className="Detail_Home_Tab_input_block_">
                <p>
                  Date of birth <span className="mendatrystrick">*</span>
                </p>

                <DateBox
                  displayFormat={getDateBoxFormat()}
                  value={Detail_Tab_Name_getData.DateOfBirth}
                  // value={formatDate(Detail_Tab_Name_getData.DateOfBirth, "MM/DD/YYYY")}
                  useMaskBehavior={true}
                  onValueChange={(e) => {
                    dispatch(
                      detail_Tab_Name_getData({
                        ...Detail_Tab_Name_getData,
                        DateOfBirth: e ? e : null,
                        isChange: true,
                      }),
                    );

                    if (!e) {
                      dispatch(
                        detail_name_tab_Validation({
                          ...Detail_name_tab_Validation,
                          DateOfBirth: "Please select date of birth",
                        }),
                      );
                    } else {
                      dispatch(
                        detail_name_tab_Validation({
                          ...Detail_name_tab_Validation,
                          DateOfBirth: "",
                        }),
                      );
                    }
                  }}
                  style={{
                    marginTop: "3.3%",
                    fontWeight: 600,
                    color: "rgba(0, 0, 0, 0.6)",
                  }}
                  disabled={!editable}
                />
                {Detail_name_tab_Validation.DateOfBirth && (
                  <p style={{ color: "red" }} className="Error">
                    {Detail_name_tab_Validation.DateOfBirth}
                  </p>
                )}
              </div>
              <div className="Detail_Home_Tab_input_block_">
                <p>SSN</p>
                <TextBox
                  style={{ marginTop: "3%" }}
                  showMaskMode="always"
                  maskRules={{
                    H: /^[0-9*]$/,
                  }}
                  mask="HHH-HH-HHHH"
                  value={ssnDisplayValue}
                  onValueChange={(e) => {
                    if (!editable) return;

                    dispatch(
                      detail_Tab_Name_getData({
                        ...Detail_Tab_Name_getData,
                        SSN: e,
                        isChange: true,
                      }),
                    );
                  }}
                  disabled={!editable}
                  isValid={true}
                />
              </div>
              <div className="Detail_Home_Tab_input_block_">
                <p>Gender</p>
                <DropDown
                  editable={editable}
                  Detail_Tab_Name_getData={Detail_Tab_Name_getData}
                  setValue={"Gender"}
                  dropDownData={gender}
                  searchMode={"startswith"}
                />
              </div>

              <div className="Detail_Home_Tab_input_block_">
                <p>Language</p>
                <DropDown
                  editable={editable}
                  Detail_Tab_Name_getData={Detail_Tab_Name_getData}
                  setValue={"Language"}
                  dropDownData={languages}
                  searchMode={"startswith"}
                />
              </div>
            </div>
            <div style={{ width: "25%" }}>
              <div className="Detail_Home_Tab_input_block_">
                <p>
                  Effective Date <span className="mendatrystrick">*</span>
                </p>
                <DateBox
                  displayFormat={getDateBoxFormat()}
                  value={Detail_Tab_Name_getData.EffectiveDate}
                  style={{
                    marginTop: "3.3%",
                  }}
                  useMaskBehavior={true}
                  onValueChange={(e) => {
                    if (e) {
                      dispatch(
                        detail_Tab_Name_getData({
                          ...Detail_Tab_Name_getData,
                          EffectiveDate: e ? e : null,
                          isChange: true,
                        }),
                      );
                      if (!e) {
                        dispatch(setefffectiveData("Please select Effective Date"));
                      } else {
                        dispatch(setefffectiveData(""));
                      }
                    }
                  }}
                  disabled={!editable}
                />
                {efffectiveData && (
                  <p style={{ color: "red" }} className="Error">
                    {efffectiveData}
                  </p>
                )}
              </div>
              <div className="Detail_Home_Tab_input_block_">
                <p>Risk/Compliance Level</p>
                <DropDown
                  editable={editable}
                  Detail_Tab_Name_getData={Detail_Tab_Name_getData}
                  setValue={"ComplianceLevel"}
                  dropDownData={complianceLevel}
                  searchMode={"startswith"}
                />
              </div>
              <div className="Detail_Home_Tab_input_block_">
                <p>
                  State Preference <span className="mendatrystrick">*</span>
                </p>
                <DropDown
                  editable={editable}
                  disabled={true}
                  Detail_Tab_Name_getData={Detail_Tab_Name_getData}
                  setValue={"StatePreference"}
                  dropDownData={statePreferences}
                  stateparticipent={stateparticipent}
                  searchMode={"startswith"}
                />
                {stateparticipent && (
                  <p style={{ color: "red" }} className="Error">
                    {stateparticipent}
                  </p>
                )}
              </div>
            </div>
            <div style={{ width: "25%" }}>
              <div className="Detail_Home_Tab_input_block_">
                <p>Height</p>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <NumberBox
                    style={{ marginTop: "2%", height: "40px" }}
                    onKeyDown={(e) => {
                      const { event } = e;
                      const str = event.key || String.fromCharCode(event.which);
                      if (/^[.,e]$/.test(str)) {
                        event.preventDefault();
                      }
                    }}
                    value={Detail_Tab_Name_getData.Height.feet}
                    disabled={!editable}
                    min={0}
                    onValueChange={(e) => {
                      dispatch(
                        detail_Tab_Name_getData({
                          ...Detail_Tab_Name_getData,
                          Height: {
                            ...Detail_Tab_Name_getData.Height,
                            feet: e,
                          },
                          isChange: true,
                        }),
                      );
                    }}
                    placeholder={`Feet`}
                  />
                  <p style={{ marginTop: "15px" }}>ft</p>

                  <NumberBox
                    style={{ marginTop: "2%", height: "40px" }}
                    onKeyDown={(e) => {
                      const { event } = e;
                      const str = event.key || String.fromCharCode(event.which);
                      if (/^[.,e]$/.test(str)) {
                        event.preventDefault();
                      }
                    }}
                    value={Detail_Tab_Name_getData.Height.inch}
                    disabled={!editable}
                    min={0}
                    onValueChange={(e) => {
                      dispatch(
                        detail_Tab_Name_getData({
                          ...Detail_Tab_Name_getData,
                          Height: {
                            ...Detail_Tab_Name_getData.Height,
                            inch: e,
                          },
                          isChange: true,
                        }),
                      );
                    }}
                    placeholder={`Inch`}
                  />
                  <p style={{ marginTop: "15px" }}>in</p>
                </div>
              </div>
              <div className="Detail_Home_Tab_input_block_">
                <p>Weight</p>
                <div style={{ display: "flex", justifyContent: "" }}>
                  <NumberBox
                    style={{ marginTop: "2%", height: "40px" }}
                    onKeyDown={(e) => {
                      const { event } = e;
                      const str = event.key || String.fromCharCode(event.which);
                      if (/^[.,e]$/.test(str)) {
                        event.preventDefault();
                      }
                    }}
                    value={Detail_Tab_Name_getData.Weight}
                    disabled={!editable}
                    min={0}
                    onValueChange={(e) => {
                      dispatch(
                        detail_Tab_Name_getData({
                          ...Detail_Tab_Name_getData,
                          Weight: e,
                          isChange: true,
                        }),
                      );
                    }}
                    placeholder={`Weight`}
                  />
                  <p style={{ marginTop: "15px" }}>lbs</p>
                </div>
              </div>
              <div className="Detail_Home_Tab_input_block_">
                <p>Race</p>
                <DropDown
                  editable={editable}
                  Detail_Tab_Name_getData={Detail_Tab_Name_getData}
                  setValue={"Race"}
                  dropDownData={race}
                  searchMode={"startswith"}
                />
              </div>
              <div className="Detail_Home_Tab_input_block_">
                <p>Hair Color</p>
                <DropDown
                  editable={editable}
                  Detail_Tab_Name_getData={Detail_Tab_Name_getData}
                  setValue={"HairColor"}
                  dropDownData={hairColor}
                  searchMode={"startswith"}
                />
              </div>
              <div className="Detail_Home_Tab_input_block_">
                <p>Eye Color</p>
                <DropDown
                  editable={editable}
                  Detail_Tab_Name_getData={Detail_Tab_Name_getData}
                  setValue={"EyeColor"}
                  dropDownData={eyeColor}
                  searchMode={"startswith"}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
